import React, { useState } from 'react'
import cn from 'classnames'
import { VerticalTabsProps } from '../types'
import styles from './accordion-view.module.scss'
import { TabContent as AccordionContent } from '../tab-content'
import { AccordionButton } from './accordion-button'
import { getColorStyleClassName } from '../utils'

export const AccordionView: React.FC<VerticalTabsProps> = ({ items, className, colorStyle }) => {
  const [openIndex, setOpenIndex] = useState<number | undefined>(0)

  const colorStyleClassName = getColorStyleClassName(colorStyle)

  return (
    <div className={className}>
      {items.map(({ title, content }, index) => {
        const isCurrentItemOpen = openIndex === index
        const buttonId = `accordion-button-${index}`
        const contentId = `accordion-content-${index}`

        return (
          <div
            key={index}
            className={cn(styles.container, {
              [styles.open]: isCurrentItemOpen,
            })}
          >
            <AccordionButton
              isActive={index === openIndex}
              content={title}
              id={buttonId}
              associatedContentId={contentId}
              onClick={() => setOpenIndex(isCurrentItemOpen ? undefined : index)}
              className={colorStyleClassName}
            />

            <AccordionContent
              content={content}
              id={contentId}
              associatedTriggerId={buttonId}
              className={cn({
                [styles.hidden]: !isCurrentItemOpen,
              })}
            />
          </div>
        )
      })}
    </div>
  )
}
